import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import moment from 'moment';

import _ from 'lodash';

import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import HighlightOffIcon from 'material-ui/svg-icons/action/highlight-off';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import { addNotification } from 'actions/notifications/notifications';
import { addYard } from 'actions/yards';
import { updateVessel, deleteVessel, addVessel, confirmVessel, updateVesselImage } from 'actions/vessels/vessels';
import OpenInNewIcon from 'material-ui/svg-icons/action/open-in-new';
import { prepareExclToLoad } from './Rows/withExclusions';
import { checkGrabs } from 'helpers/vessels';
import { TextField } from 'material-ui';

class Sidebar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openDialogDelete: false,
            openDialogDeleteImage: false,
            parentState: props.parentState,
            confirmed: props.confirmed,
            vesselDeleteReason: '',
        };

        this.addVessel = this.addVessel.bind(this);
        this.deleteVessel = this.deleteVessel.bind(this);
        this.updateVessel = this.updateVessel.bind(this);
        this.toggleDialog = this.toggleDialog.bind(this);
        this.confirmVessel = this.confirmVessel.bind(this);
        this.updateImageOnly = this.updateImageOnly.bind(this);
        this.changeVesselDeleteReason = this.changeVesselDeleteReason.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.parentState.image !== this.state.parentState.image
            || nextState.parentState.attachmentsArray !== this.state.parentState.attachmentsArray
            || nextState.openDialogDelete !== this.state.openDialogDelete
            || nextState.openDialogDeleteImage !== this.state.openDialogDeleteImage
            || nextProps.confirmed !== this.state.confirmed
            || nextState.vesselDeleteReason !== this.state.vesselDeleteReason;
    }

    /**
     * The function serializes the vessel data into a backend JSON.
     */
    prepareToLoad(vessel) {
        if (vessel.errors.length > 0) {
            const el = document.getElementsByName(vessel.errors[0].field)[0];
            el.scrollIntoView();

            return;
        }

        vessel.flag = _.has(vessel, 'flagObject._id') && vessel.flagObject._id !== '' ? vessel.flagObject._id : undefined;
        if (vessel.builderV2.countryObject) {
            vessel.builderV2.country = _.has(vessel, 'builderV2.countryObject._id') && vessel.builderV2.countryObject._id !== '' ?
                vessel.builderV2.countryObject._id : undefined;
            delete vessel.builderV2.countryObject
        } else {
            vessel.builderV2.country = _.has(vessel, 'builderV2.country._id') && vessel.builderV2.country._id !== '' ?
                vessel.builderV2.country._id : undefined;
        }
        vessel.piClub = _.has(vessel, 'piClubObject._id') && vessel.piClubObject._id !== '' ? vessel.piClubObject._id : undefined;
        vessel.cargoExclusionV2 = _.has(vessel, 'cargoExclusionV2Object._id') &&
            vessel.cargoExclusionV2Object._id !== '' ? vessel.cargoExclusionV2Object._id.map(excl => excl.cargoExclusion._id) : undefined;
        vessel.owner = _.has(vessel, 'owner._id') && vessel.owner._id !== '' ? vessel.owner._id : undefined;
        vessel.registeredOwner = vessel.registeredOwnerObject;
        vessel.manager = _.has(vessel, 'managerObject._id') && vessel.managerObject._id !== '' ? vessel.managerObject._id : undefined;
        vessel.homePort = _.has(vessel, 'homePortObject._id') && vessel.homePortObject._id !== '' ? vessel.homePortObject._id : undefined;

        if (vessel.gearV2) {
            vessel.gearV2.summary.forEach((gear) => {
                gear.quantity = parseFloat(gear.quantity) || undefined;
                gear.capacity = parseFloat(gear.capacity) || undefined;
                gear.outreach = parseFloat(gear.outreach) || undefined;
                gear.maxSWL = parseFloat(gear.maxSWL) || undefined;
            });
        }

        delete vessel.gears;

        vessel.grabV2.summary = checkGrabs(vessel.grabV2.summary);

        vessel.bunkers = this.checkIfEmptyArray(vessel.bunkers);

        if (vessel.rt) {
            vessel.rt.panamaNt = vessel.rt.panamaNt || undefined;
            vessel.rt.suezGt = vessel.rt.suezGt || undefined;
            vessel.rt.suezNt = vessel.rt.suezNt || undefined;
            vessel.rt.nt = vessel.rt.nt || undefined;
            vessel.rt.gt = vessel.rt.gt || undefined;
        }

        if (vessel.dimensions) {
            for (const [key, value] of Object.entries(vessel.dimensions)) {
                if (!value) {
                    vessel.dimensions[key] = undefined;
                }
            }
        }

        if (vessel.engines) {
            for (let i = 0; i < vessel.engines.length; i++) {
                const engine = vessel.engines[i];
                for (const [key, value] of Object.entries(engine)) {
                    if (!value) {
                        engine[key] = undefined;
                    }
                }
            }
        }

        if (vessel.deadWeight) {
            for (const [key, value] of Object.entries(vessel.deadWeight)) {
                vessel.deadWeight[key] = value ? parseFloat(value) : undefined;
            }
        }

        if (vessel.techEquipCertificate) {
            for (const [key, value] of Object.entries(vessel.techEquipCertificate)) {
                if (!value) {
                    vessel.techEquipCertificate[key] = undefined;
                }
            }
            const { igs } = vessel.techEquipCertificate;
            if (igs) {
                igs.fitted = igs.fitted || undefined;
                if (igs.systems) {
                    igs.systems = igs.systems
                        .filter(s => s.type || s.capacity || s.percentage)
                        .map(s => ({
                            type: s.type || undefined,
                            capacity: parseFloat(s.capacity) || undefined,
                            percentage: parseFloat(s.percentage) || undefined,
                        }));
                }
            }
        }

        if (vessel.areas) {
            vessel.areas.mainDeck = vessel.areas.mainDeck || undefined;
            vessel.areas.tweenDeck = vessel.areas.tweenDeck || undefined;
            vessel.areas.weatherDeck = vessel.areas.weatherDeck || undefined;
            vessel.areas.total = vessel.areas.total || undefined;
        }

        if (vessel.strength) {
            vessel.strength.maxTt = vessel.strength.maxTt || undefined;
            vessel.strength.maxTween = vessel.strength.maxTween || undefined;
            vessel.strength.maxWeather = vessel.strength.maxWeather || undefined;
        }

        if (vessel.stackWeight) {
            vessel.stackWeight['20hold'] = vessel.stackWeight['20hold'] || undefined;
            vessel.stackWeight['20deck'] = vessel.stackWeight['20deck'] || undefined;
            vessel.stackWeight['40hold'] = vessel.stackWeight['40hold'] || undefined;
            vessel.stackWeight['40deck'] = vessel.stackWeight['40deck'] || undefined;
        }

        if (vessel.cargoExclusionsV2.length) {
            vessel.cargoExclusionsV2 = prepareExclToLoad(vessel.cargoExclusionsV2, vessel.isRewriteOwnerExclusions);
        }

        if (vessel.tradingRestrictions.length) {
            vessel.tradingRestrictions = prepareExclToLoad(vessel.tradingRestrictions, vessel.isRewriteOwnerExclusions);
        }

        vessel.cells = vessel.cells.filter((item) => {
            const holdsLen = Object.values(item.holds).filter(_item => _item).length;
            const tweenDecksLen0 = Object.values(item.tweenDecks[0]).filter(_item => _item).length;
            const tweenDecksLen1 = Object.values(item.tweenDecks[1]).filter(_item => _item).length;

            const hatchesLen0 = Object.values(item.hatches[0]).filter(_item => _item).length;
            const hatchesLen1 = Object.values(item.hatches[1]).filter(_item => _item).length;

            return holdsLen || tweenDecksLen0 || tweenDecksLen1 || hatchesLen0 || hatchesLen1;
        });

        if (vessel.cells) {
            vessel.cells.forEach((cell) => {
                cell.holds.l = parseFloat(cell.holds.l) || undefined;
                cell.holds.b = parseFloat(cell.holds.b) || undefined;
                cell.holds.h = parseFloat(cell.holds.h) || undefined;
                cell.holds.area = parseFloat(cell.holds.area) || undefined;

                cell.tweenDecks[0].l = parseFloat(cell.tweenDecks[0].l) || undefined;
                cell.tweenDecks[0].b = parseFloat(cell.tweenDecks[0].b) || undefined;
                cell.tweenDecks[0].h = parseFloat(cell.tweenDecks[0].h) || undefined;
                cell.tweenDecks[0].area = parseFloat(cell.tweenDecks[0].area) || undefined;

                cell.tweenDecks[1].l = parseFloat(cell.tweenDecks[1].l) || undefined;
                cell.tweenDecks[1].b = parseFloat(cell.tweenDecks[1].b) || undefined;
                cell.tweenDecks[1].h = parseFloat(cell.tweenDecks[1].h) || undefined;
                cell.tweenDecks[1].area = parseFloat(cell.tweenDecks[1].area) || undefined;

                cell.hatches[0].l = parseFloat(cell.hatches[0].l) || undefined;
                cell.hatches[0].b = parseFloat(cell.hatches[0].b) || undefined;
                cell.hatches[0].area = parseFloat(cell.hatches[0].area) || undefined;

                cell.hatches[1].l = parseFloat(cell.hatches[1].l) || undefined;
                cell.hatches[1].b = parseFloat(cell.hatches[1].b) || undefined;
                cell.hatches[1].area = parseFloat(cell.hatches[1].area) || undefined;
            });
        }

        if (vessel.speedConsumptionV2) {
            vessel.speedConsumptionV2.forEach((val) => {
                val.speed = parseFloat(val.speed) || undefined;
                val.ifo.cons = parseFloat(val.ifo.cons) || undefined;
                val.mdo.cons = parseFloat(val.mdo.cons) || undefined;
                val.lngCons = parseFloat(val.lngCons) || undefined;
            });
        }

        delete vessel.consumptions;

        vessel.speedConsumptionV2 = vessel.speedConsumptionV2.filter(item => item.mode);

        if (vessel.capacityV2) {
            vessel.capacityV2.constant = parseFloat(vessel.capacityV2.constant) || undefined;
            vessel.capacityV2.grain = parseFloat(vessel.capacityV2.grain) || undefined;
            vessel.capacityV2.bale = parseFloat(vessel.capacityV2.bale) || undefined;
            vessel.capacityV2.teu = parseFloat(vessel.capacityV2.teu) || undefined;
            vessel.capacityV2.feu = parseFloat(vessel.capacityV2.feu) || undefined;

            vessel.capacityV2.summary.forEach((item) => {
                item.hold.grain = parseFloat(item.hold.grain) || undefined;
                item.hold.bale = parseFloat(item.hold.bale) || undefined;
                item.hold.teu = parseFloat(item.hold.teu) || undefined;
                item.hold.feu = parseFloat(item.hold.feu) || undefined;

                item.tweenDeck.grain = parseFloat(item.tweenDeck.grain) || undefined;
                item.tweenDeck.bale = parseFloat(item.tweenDeck.bale) || undefined;
                item.tweenDeck.teu = parseFloat(item.tweenDeck.teu) || undefined;
                item.tweenDeck.feu = parseFloat(item.tweenDeck.feu) || undefined;
            });
        }

        vessel.capacityV2.summary = this.checkCapacity(vessel.capacityV2.summary);

        if (vessel.gearV2) {
            vessel.gearV2.summary.forEach((gear) => {
                gear.type = gear.type || '';
                gear.quantity = gear.quantity || undefined;
                gear.capacity = gear.capacity || undefined;
                gear.outreach = gear.outreach || undefined;
                gear.maxSWL = gear.maxSWL || undefined;
            });
        }

        if (vessel.grabV2) {
            vessel.grabV2.summary.forEach((grab) => {
                grab.type = grab.type || '';
                grab.quantity = grab.quantity || undefined;
                grab.volume = grab.volume || undefined;
            });
        }

        if (vessel.holds) {
            vessel.holds.quantity = vessel.holds.quantity || undefined;

            if (vessel.holds.lowerDims && vessel.holds.lowerDims.length) {
                vessel.holds.lowerDims.forEach((dim) => {
                    dim.l = dim.l || undefined;
                    dim.b = dim.b || undefined;
                    dim.h = dim.h || undefined;
                });
            }

            if (vessel.holds.tweenDims && vessel.holds.tweenDims.length) {
                vessel.holds.tweenDims.forEach((dim) => {
                    dim.l = dim.l || undefined;
                    dim.b = dim.b || undefined;
                    dim.h = dim.h || undefined;
                });
            }
        }
        if (vessel.hatches) {
            if (vessel.hatches.hatchType === 'Mc Greegor') {
                vessel.hatches.hatchType = 'Mc Gregor';
            }
            if (vessel.hatches.size && vessel.hatches.size.length) {
                vessel.hatches.size.forEach((dim) => {
                    dim.l = dim.l || undefined;
                    dim.b = dim.b || undefined;
                });
            }
        }

        if (vessel.bunkers.length > 0) {
            vessel.bunkers = vessel.bunkers.filter(item => item.quantity && item.typeOfFuel);
        }

        vessel.imoClass = vessel.imoClass || undefined;

        if (!vessel.disponentOwner._id && !vessel.disponentOwner.name) {
            delete vessel.disponentOwner;
        }

        if (vessel.pumps && vessel.pumps.cargo) {
            vessel.pumps.cargo = vessel.pumps.cargo
                .filter(p => p.type || p.quantity || p.capacity);
        }
        if (vessel.pumps && vessel.pumps.ballast) {
            vessel.pumps.ballast = vessel.pumps.ballast
                .filter(p => p.type || p.quantity || p.capacity);
        }
        if (vessel.registerClasses) {
            vessel.registerClasses = vessel.registerClasses
                .filter(c => c.name && (c._id || c.iacsRegister === true || c.iacsRegister === false))
                .map(c => ({
                    _id: c._id || undefined,
                    name: c.name || undefined,
                    iacsRegister: (c.iacsRegister === true || c.iacsRegister === false)
                        ? c.iacsRegister
                        : undefined,
                }));
            vessel.registerClass = undefined;
        }
        if (vessel.capacityTanker.tanks) {
            vessel.capacityTanker.tanks = vessel.capacityTanker.tanks
                .filter(t => t.port || t.starboard);
        }
        if (vessel.capacityTanker.slops) {
            vessel.capacityTanker.slops = vessel.capacityTanker.slops
                .filter(t => t.port || t.starboard);
        }
        if (vessel.capacityTanker.ballastTanks) {
            vessel.capacityTanker.ballastTanks = vessel.capacityTanker.ballastTanks
                .filter(t => t.port || t.starboard);
        }
        if (vessel.manifolds && vessel.manifolds.list) {
            vessel.manifolds.list = vessel.manifolds.list
                .filter(m => m.number || m.size || m.commonLine);
        }
        if (vessel.lastCargo) {
            vessel.lastCargo = vessel.lastCargo
                .map(tank => ({
                    cargoes: tank.cargoes
                        .filter(c => c.cargo._id && c.date)
                        .map(c => ({
                            ...c,
                            cargo: c.cargo._id.toString(),
                        })),
                }));
        }
        if (vessel.certificateOfFitness) {
            vessel.certificateOfFitness = vessel.certificateOfFitness
                .map(c => c._id);
        }
        if (vessel.strength && vessel.strength.tanktopByHolds) {
            vessel.strength.tanktopByHolds = vessel.strength.tanktopByHolds
                .map(s => parseInt(s, 10))
                .filter(s => !isNaN(s));
        }

        vessel.capacityTanker.wholeTank = !!vessel.capacityTanker.wholeTank;
        vessel.capacityTanker.heating.medium = vessel.capacityTanker.heating.medium || undefined;

        delete vessel.registeredOwnerObject;
        delete vessel.draft;
        delete vessel.tonnage;
        delete vessel.dw;
        delete vessel.capacity;
        delete vessel.speeds;
        return vessel;
    }

    addVessel() {
        let vessel = _.cloneDeep(this.props.parentState);
        vessel = this.prepareToLoad(vessel);

        if (!vessel.typeByPurpose) {
            const el = document.getElementById('typeByPurposeSection');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });

            return this.props.addNotification({
                title: 'Error',
                message: 'Type by purpose is required',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 5,
            });
        }

        vessel && this.props.addVessel(vessel);
    }

    confirmVessel() {
        this.props.confirmVessel(this.props.parentState._id);
        this.props.changeField({
            field: 'typeOfPage',
            value: 'update',
        });

        this.props.changeField({
            field: 'confirmed',
            value: 'true',
        });
    }

    updateVessel() {
        let vessel = _.cloneDeep(this.props.parentState);
        vessel = this.prepareToLoad(vessel);

        if (!vessel.typeByPurpose) {
            const el = document.getElementById('typeByPurposeSection');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });

            return this.props.addNotification({
                title: 'Error',
                message: 'Type by purpose is required',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 5,
            });
        }

        if (vessel.deadWeight.sDraft > parseInt(vessel.dimensions.depth)) {
            const el = document.getElementById('deadweightSection');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });

            return this.props.addNotification({
                title: 'Error',
                message: 'Draft cannot exceed Depth.',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 5,
            });
        }

        vessel && this.props.updateVessel(vessel);
    }

    deleteVessel() {
        if (!this.state.vesselDeleteReason) {
            return this.props.addNotification({
                title: 'Error',
                message: 'Reason is required',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 5,
            });
        }

        this.props.deleteVessel(this.props.parentState, this.state.vesselDeleteReason);
    }

    checkIfEmptyAndReplace(array) {
        return array.map((item) => {
            for (const key in item) {
                if (item[key]) {
                    return item;
                }
            }

            return {};
        });
    }

    checkIfEmptyArray(array) {
        return array.filter((item) => {
            for (const key in item) {
                return !!item[key];
            }
        });
    }

    checkGears(array) {
        return array.filter((item) => {
            if (item.combinable) {
                return true;
            }

            for (const key in item) {
                if (key !== 'combinable') {
                    return !!item[key];
                }
            }
        });
    }

    checkCapacity(array) {
        return array.filter((item) => {
            const {
                hold: {
                    grain: hg, bale: hb, teu: ht, feu: hf,
                },
                tweenDeck: {
                    grain: tg, bale: tb, teu: tt, feu: tf,
                },
            } = item;

            return hg || hb || ht || hf || tg || tb || tt || tf;
        });
    }

    toggleDialog(field) {
        this.setState({
            [field]: !this.state[field],
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            parentState: nextProps.parentState,
            confirmed: nextProps.confirmed,
        });
    }

    updateImageOnly() {
        const { images, _id } = this.props.parentState;
        if (images && images[0]) {
            this.props.updateVesselImage(_id, images[0]);
        }
    }

    renderMarkForDeletion = () => (
        this.props.markForDeletion ? 
            <div 
                className='paper-block margin-bottom center-xs' 
                style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    color: '#d32f2f', 
                    fontWeight: 'bold',
                    padding: '15px 10px',
                    border: '2px solid #d32f2f',
                    backgroundColor: '#ffebee',
                    borderRadius: '4px',
                    position: 'relative',
                    gap: '5px',
                }}
            >
                <div className='name-block absolute small-name' style={{ color: '#d32f2f', backgroundColor: '#ffebee' }}>
                    Deletion info
                </div>
                {this.props.markForDeletion && <div>Marked for Deletion</div>}
                {this.props.markForDeletionDate && <div>Marked on: {moment(this.props.markForDeletionDate).format('DD-MM-YYYY HH:mm')}</div>}
            </div> :
            null
    )
    changeVesselDeleteReason(e) {
        this.setState({
            vesselDeleteReason: e.target.value,
        });
    }

    render() {
        const { openDialogDelete, openDialogDeleteImage, confirmed, vesselDeleteReason } = this.state;
        const {
            typeOfPage, loadImage, loadAttachment, removeAttachment, removeImage,
        } = this.props;
        const { image, attachmentsArray, deleteBy, deleteAt, deleteReason } = this.state.parentState;

        const getDialogActions = (type) => {
            if (type === 'deleteVessel') {
                return [
                    <FlatButton
                        label="Cancel"
                        primary
                        onClick={() => this.toggleDialog('openDialogDelete')}
                    />,
                    <FlatButton
                        label="Submit"
                        primary
                        onClick={this.deleteVessel}
                    />,
                ];
            } else if (type === 'deleteImage') {
                return [
                    <FlatButton
                        label="Cancel"
                        primary
                        onClick={() => this.toggleDialog('openDialogDeleteImage')}
                    />,
                    <FlatButton
                        label="Submit"
                        primary
                        onClick={() => {
                            removeImage();
                            this.toggleDialog('openDialogDeleteImage');
                        }}
                    />,
                ];
            }

            return [];
        };

        return (
            <Fragment>
                <Dialog
                    title={confirmed ? 'Reject' : 'Delete'}
                    actions={getDialogActions('deleteVessel')}
                    modal={false}
                    open={openDialogDelete}
                    onRequestClose={() => this.toggleDialog('openDialogDelete')}
                >
                    Do you want to {confirmed ? 'reject' : 'delete'} this vessel?

                    <TextField
                        floatingLabelText='Reason'
                        value={vesselDeleteReason}
                        fullWidth
                        required
                        onChange={this.changeVesselDeleteReason}
                        errorText={vesselDeleteReason ? '' : 'Reason is required'}
                    />
                </Dialog>
                <Dialog
                    title='Delete image'
                    actions={getDialogActions('deleteImage')}
                    modal={false}
                    open={openDialogDeleteImage}
                    onRequestClose={() => this.toggleDialog('openDialogDeleteImage')}
                >
                    Do you want to delete image?
                </Dialog> {
                    typeOfPage === 'new' ?
                        <div className='paper-block margin-bottom middle-xs center-xs' style={{ display: 'flex' }}>
                            <div className='name-block absolute small-name'>Management</div>
                            <RaisedButton
                                primary
                                label='Create'
                                onClick={this.addVessel}
                            />
                        </div>
                        :
                        <Fragment>
                            {
                                !deleteBy ?
                                    <div className='paper-block margin-bottom middle-xs center-xs' style={{ display: 'flex' }}>
                                        {
                                            confirmed ?
                                                <Fragment>
                                                    <RaisedButton
                                                        primary
                                                        label='Confirm'
                                                        style={{ margin: '0 20px 0 0' }}
                                                        onClick={this.confirmVessel}
                                                    />
                                                    <RaisedButton
                                                        secondary
                                                        label='Reject'
                                                        onClick={() => this.toggleDialog('openDialogDelete')}
                                                    />
                                                </Fragment>
                                                :
                                                <Fragment>
                                                    <RaisedButton
                                                        primary
                                                        label='Update'
                                                        style={{ margin: '0 20px 0 0' }}
                                                        onClick={this.updateVessel}
                                                    />
                                                    <RaisedButton
                                                        secondary
                                                        label='Delete'
                                                        onClick={() => this.toggleDialog('openDialogDelete')}
                                                    />
                                                </Fragment>
                                        }
                                    </div>
                                    :
                                    <div className='paper-block margin-bottom' style={{ padding: '20px 15px 15px' }}>
                                        <div className='name-block absolute small-name' style={{ color: '#f44336' }}>Deletion Info</div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                                                <span style={{ color: '#757575' }}>Deleted by:</span>
                                                <span style={{ fontWeight: 500 }}>{deleteBy}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                                                <span style={{ color: '#757575' }}>Deleted at:</span>
                                                <span style={{ fontWeight: 500 }}>{deleteAt}</span>
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', fontSize: '13px', borderTop: '1px solid #eee', paddingTop: '8px', marginTop: '4px' }}>
                                                <span style={{ color: '#757575', marginBottom: '4px' }}>Reason:</span>
                                                <span style={{ fontWeight: 500, fontStyle: 'italic', wordBreak: 'break-word', color: '#333' }}>{deleteReason}</span>
                                            </div>
                                        </div>
                                    </div>
                            }
                            {this.renderMarkForDeletion()}
                        </Fragment>
                }
                <div className='paper-block margin-bottom center-xs' style={{ display: 'flex', flexFlow: 'wrap' }}>
                    <div className='name-block absolute small-name'>Image</div>
                    <div style={{ position: 'relative' }}>
                        {image ?
                            (
                                <React.Fragment>
                                    <IconButton
                                        style={{
                                            position: 'absolute', right: 0, width: '36px', height: '36px', padding: 0,
                                        }}
                                    >
                                        <HighlightOffIcon
                                            color='red'
                                            onClick={() => this.toggleDialog('openDialogDeleteImage')}
                                        />
                                    </IconButton>
                                    <img
                                        style={{ width: '100%' }}
                                        src={image}
                                        alt='alt1'
                                    />
                                </React.Fragment>
                            )
                            :
                            null
                        }
                    </div>
                    {!deleteBy ?
                        <RaisedButton
                            disabled={confirmed}
                            containerElement='label'
                            label={image ? 'Change image' : 'Add image'}
                            labelStyle={{ fontSize: '11px' }}
                        >
                            <input
                                type="file"
                                accept="image/*"
                                onChange={loadImage}
                                style={{ display: 'none' }}
                            />
                        </RaisedButton>
                        : ''
                    }
                    {
                        image &&
                        <RaisedButton
                            primary
                            label='Update image only'
                            style={{ marginLeft: '8px' }}
                            labelStyle={{ fontSize: '11px' }}
                            onClick={this.updateImageOnly}
                        />
                    }
                </div>
                <div className='paper-block margin-bottom middle-xs center-xs' style={{ display: 'flex' }}>
                    <RaisedButton
                        primary
                        label='Back to list'
                        containerElement={<Link to='/vessels/list' />}
                    />
                </div>
                {
                    this.state.parentState._id ?
                        <div className='paper-block margin-bottom'>
                            <a
                                target='_blank'
                                rel='noopener noreferrer'
                                href={`/vessels/composition?_id=${this.state.parentState._id}&name=${this.state.parentState.name}`}
                                style={{
                                    display: 'flex', alignItems: 'center', color: 'inherit', fontSize: '14px',
                                }}
                            >
                                <OpenInNewIcon className='icon' color='#757575' size={20} style={{ marginRight: '5px' }} />
                                Open composition
                            </a>
                        </div>
                        :
                        null
                }
                {
                    this.state.parentState.imoNumber ?
                        <div className='paper-block margin-bottom'>
                            <a
                                target='_blank'
                                rel='noopener noreferrer'
                                href={`https://www.vesselfinder.com/vessels/details/${this.state.parentState.imoNumber}`}
                                style={{
                                    display: 'flex', alignItems: 'center', color: 'inherit', marginBottom: '10px', fontSize: '14px',
                                }}
                            >
                                <OpenInNewIcon className='icon' color='#757575' size={20} style={{ marginRight: '5px' }} />
                                Open on vesselfinder.com
                            </a>
                            <a
                                target='_blank'
                                rel='noopener noreferrer'
                                href={`https://www.marinetraffic.com/en/ais/details/ships/imo:${this.state.parentState.imoNumber}`}
                                style={{
                                    display: 'flex', alignItems: 'center', color: 'inherit', fontSize: '14px',
                                }}
                            >
                                <OpenInNewIcon className='icon' color='#757575' size={20} style={{ marginRight: '5px' }} />
                                Open on marinetraffic.com
                            </a>
                        </div>
                        : null
                }
                <div className='paper-block margin-bottom center-xs' style={{ display: 'flex', flexFlow: 'wrap' }}>
                    <div className='name-block absolute small-name'>Attachments</div>
                    <div className='attachments-list'>
                        {
                            attachmentsArray.map((item, key) => (
                                <div key={key} className='item'>
                                    <div className='name'>
                                        <a href={item.url} target="_blank">{item.name}</a>
                                    </div>
                                    {!deleteBy ?
                                        <IconButton>
                                            <ContentRemoveIcon
                                                onClick={() => {
                                                    removeAttachment(key);
                                                }}
                                                color='red'
                                            />
                                        </IconButton>
                                        : ''
                                    }
                                </div>
                            ))
                        }
                    </div>
                    {!deleteBy ?
                        <RaisedButton disabled={confirmed} containerElement='label' label='Add' >
                            <input
                                type="file"
                                accept="xls, .xlsx, .txt, .csv, .pdf, .jpg, .jpeg, .png, .doc, .docx, .rtf"
                                onChange={(e) => {
                                    loadAttachment(e);
                                }}
                                style={{ display: 'none' }}
                            />
                        </RaisedButton>
                        : ''
                    }
                </div>

            </Fragment>
        );
    }
}

export default connect(
    (state, { parentState, changeField, typeOfPage }) => ({
        parentState,
        changeField,
        typeOfPage,
    }),
    dispatch => bindActionCreators({
        addVessel,
        addYard,
        updateVessel,
        deleteVessel,
        addNotification,
        confirmVessel,
        updateVesselImage,
    }, dispatch),
)(Sidebar);



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Sidebar.jsx